(() => {
  const fuchsiaPath = '/collections/quinceanera-dresses/fuchsia';
  const allColorsPath = '/collections/quinceanera-dresses';

  document.addEventListener(
    'click',
    (event) => {
      if (window.location.pathname.replace(/\/$/, '') !== fuchsiaPath) return;

      const resetLink = event.target.closest('facet-remove a');
      if (!resetLink) return;

      const label = resetLink.textContent.trim().toLowerCase();
      if (label !== 'reset' && label !== 'remove all') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(allColorsPath);
    },
    true
  );
})();
